import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../ui/Dialog/DialogActions";
import Button from "../../../../../../../ui/Button";
import TextField from "../../../../../../../ui/TextField";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  dialog: {
    width: "550px"
  }
})

const AddBlockDialog = ({ open, type = "add",
                          handleClose,
                          addBlock,
                          updateBlock,
                          isLoading,
                          classes
}) => {
  const [number, setNumber] = React.useState(null);
  const [name, setName] = React.useState(null);
  //const [data, setData] = React.useState(null);
  //const [formBlockData, updateFormBlockData] = React.useState(null);

  const handleCreateBlock = () => {
    const data = {
      number: number,
      name: name
    };
    addBlock && addBlock(data);
    handleClose();
  };

  const handleUpdateBlock = () => {
    const data = {
      number: number,
      name: name
    };
    updateBlock && updateBlock(data);
    handleClose();
  };

  return (
    <div>
      <Dialog onClose={handleClose}
              aria-labelledby="customized-dialog-title"
              open={open}
              PaperProps={{
                className: classes.dialog
              }}>
        <div>
          <DialogTitle>{type === "add" ? "Добавить блок" : "Обновить блок"}</DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={2}>
                  required
                  label="Номер"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  name="name"
                  required
                  label="Наименование"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  InputLabelProps={{
                    shrink: true
                  }}
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose}>Отмена</Button>
            <Button
              onClick={() => (type === "add" ? handleCreateBlock() : handleUpdateBlock())}
              color="green"
            >
              {type === "add" ? "Добавить" : "Обновить"}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(AddBlockDialog);
